import { render, staticRenderFns } from "./ReadOnlyV2.vue?vue&type=template&id=8a15afe0&scoped=true&"
import script from "./ReadOnlyV2.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a15afe0",
  null
  
)

export default component.exports